import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseConfigLocationActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Location/LocationBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseConfigLocation"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseConfigLocation"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseConfigLocationActivity)
